import React, { PureComponent, memo } from 'react';
import { connect } from "react-redux";

import {
  getEventsList
} from "../../actions";

import { Navigation } from "./navigation";
import { EventListingComponent } from "./eventListing";
import { LoaderComponent } from '../../components/loader';

let hierarchyArr = [
	{
		id: 0,
		name: 'all events',
		description: 'event list description',
		metaDescription: 'event list meta desc',
		tierInUrl: "/all-events",
	},
]

class AllEventPage extends PureComponent {
  componentDidMount(){
    if (!this.props.upcoming_events && !this.props.previous_events) {
			this.props.getEventsList("all");
		}
  }
  render() {
    return (
			<React.Fragment>
				<div className="container">
        <LoaderComponent isLoading={ this.props.isListLoading} />
        {!this.props.isListLoading &&
          <>
            <section className="event-navigation">
              <Navigation
                hierarchy={hierarchyArr}
                eventName={this.props.upcoming_events && this.props.upcoming_events?.[0]?.title.en}
                imageUrl={this.props.upcoming_events && this.props.upcoming_events?.[0]?.event_image_file_base.path}              
              />
            </section>
            <section
              className="container event-list"
              ref={this.lazyLoadContainer}
            >
              <div className="upcoming-events">
                <div className="list-header d-flex flex-row justify-content-between align-items-center">
                  <h1>
                    Upcoming Events
                  </h1>
                  {this.props.upcoming_events && this.props.upcoming_events.length > 0 &&                  
                    <a className="seeAll" href="/upcoming-events">
                      See all
                    </a>
                  }
                </div>
                <EventListingComponent
                  type="Upcoming Events"
                  listing={this.props.upcoming_events && this.props.upcoming_events.length > 0 ? this.props.upcoming_events.slice(0, 2): []}
                  isColumn={true}
                  currentLanguage={this.props.currentLanguage}
                />
              </div>
            </section>       
            <section
              className="container event-list"
              ref={this.lazyLoadContainer}
              >
                <div className="previous-events">
                  <div className="list-header d-flex flex-row justify-content-between align-items-center">
                    <h1>
                      Previous Events
                    </h1>
                    {this.props.previous_events && this.props.previous_events.length > 0 &&  
                      <a className="seeAll" href="/previous-events">
                        See All
                      </a>
                    }
                  </div>
                  <div className="row">
                    <EventListingComponent
                      type="Previous Events"
                      listing={this.props.previous_events && this.props.previous_events.length > 0 ? this.props.previous_events : []}
                      currentLanguage={this.props.currentLanguage}
                    />
                  </div>
                </div>
            </section>
          </>
        }
      </div>
			</React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    isListLoading:  state.eventDetails.isListLoading,
    upcoming_events: state.eventDetails.upcoming_events,
    previous_events: state.eventDetails.previous_events,
    currentLanguage: state.language.currentLanguage,
  };
};

function mapDispatchToProps(dispatch) {
  return{
    getEventsList: () => dispatch(getEventsList("all"))
  }
}

function loadData(store) {
  let actionArray = [
    store.dispatch(getEventsList('all')),
  ];
  return actionArray;
}


export default { loadData,
  component: connect(mapStateToProps, mapDispatchToProps)(memo(AllEventPage))
};